import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { rulesManagementStoreSelector } from '../rulesManagement.selector';

export const hasRuleValidationErrorsSelector = createCachedSelector(
  [
    path(rulesManagementStoreSelector).invalidRules(),
  ],
  (invalidRules) => {
    return invalidRules.size > 0;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
